import { Translate as $t } from "@/plugins/translate";
import { TabsByStatusTimeCounterType } from "@/types/dashboard/tabsByStatusTimeCounter";
import { TabsByStatusTimeCounterInterface } from "@/interface/dashboard";

class TabsByStatusTimeCounter implements TabsByStatusTimeCounterInterface {
  list: Array<TabsByStatusTimeCounterType> = [];

  constructor(data?: Array<TabsByStatusTimeCounterType>) {
    if (data) {
      this.list = data;
    }
  }

  toChartDate(): Array<any> {
    const dataGroupByStatus: any = Object.assign({});
    this.list
      .sort((a, b) => {
        return new Date(a.creation_time).getTime() - new Date(b.creation_time).getTime();
      })
      .forEach((item) => {
        if (dataGroupByStatus[item.status] == undefined) {
          dataGroupByStatus[item.status] = [];
        }
        dataGroupByStatus[item.status].push({ x: item.creation_time, y: item.count });
      });

    const chartData: Array<object> = [];
    for (let name in dataGroupByStatus) {
      const data = dataGroupByStatus[name];
      chartData.push({
        name: $t(`order_status.${name}`),
        data,
      });
    }
    return window._.orderBy(chartData, ["data"], ["desc"]);
  }

  getOrderCount() {
    let allOrdersCount = 0;
    let completedOrdersCount = 0;
    this.list.map((item) => {
      allOrdersCount += item.count;
      if (item.status == "CLOSED") {
        completedOrdersCount = item.count;
      }
    });
    return { allOrdersCount: allOrdersCount, completedOrdersCount: completedOrdersCount };
  }
}

export default TabsByStatusTimeCounter;
